// https://github.com/sindresorhus/normalize-url
import normalizeUrl from 'normalize-url'
export default normalizeUrl
